import PropTypes from 'prop-types';
import React, { useState, Fragment } from 'react';
import Image from '../commonComponents/image/Image';
import { FacebookShareButton } from 'react-share';
import { Link } from '../commonComponents';
import { LinkEMEA } from '../commonComponents';

import { comparePath } from 'Root/utils';
import SubItem from './SubItem';
import { language, redirectToEnglish, redirectToArabic } from '../../constants';

const Item = ({
  text,
  image,
  activeImage,
  path,
  onClick = true,
  href,
  share = false,
  location,
  subMenus = false,
  liClassName,
  externalLink=false,
}) => {
  const [hovered, setHovered] = useState(false);
  const [subActived, setSubActived] = useState(false);
  const active = comparePath(location, path, 1, '/');
  const className = active ? 'link--text active' : 'link--text';
  image = active || hovered ? activeImage : image;
  liClassName = !subMenus ? liClassName : subActived ? liClassName + ' active up' : liClassName + ' down';

  const toggleHover = () => setHovered(!hovered);
  const toggleSubActive = () => setSubActived(!subActived);

  const fbButton = (
    <FacebookShareButton url={href}>
      <Image className="icons--main-nav" src={image} />
      <span className={className}>{text}</span>
    </FacebookShareButton>
  );
  const normalButton = (
    <>
      <Image className="icons--main-nav" src={image} />
      <Fragment>
          <span className={className}
            dangerouslySetInnerHTML={{ __html: text }}
            />
      </Fragment>
    </>
  );
  const dropDownMenuWrapper = () => {
    if(subMenus) {
      return <Fragment>
        <div onClick={toggleSubActive} className="sub-menu-open"><span></span></div>
        <SubItem
          href={href}
          path={path}
          share={share}
          onClick={onClick}
          subMenus={subMenus}
        />
      </Fragment>
    }
    return;
  }
    
  return (
    <Fragment>
      <li className={liClassName} onMouseEnter={toggleHover} onMouseLeave={toggleHover} data-layer-menu_item={liClassName}>
        {language==='arabia' || language==='arabia_en'?
        <LinkEMEA
        className="link"
        onClick={onClick}
        to={{
          pathname: path,
        }}
        href={href}
        externalLink={externalLink}
        target={href===redirectToEnglish || href===redirectToArabic?"":"_blank"}
      >
        {share ? fbButton : normalButton}
      </LinkEMEA>
        :
        <Link
          className="link"
          onClick={onClick}
          to={{
            pathname: path,
          }}
          href={href}
          target="_blank"
        >
          {share ? fbButton : normalButton}
        </Link>}
        {dropDownMenuWrapper()}
      </li>
    </Fragment>
  );
};

Item.propTypes = {
  text: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  activeImage: PropTypes.string.isRequired,
  path: PropTypes.string,
  onClick: PropTypes.func,
  href: PropTypes.string,
  share: PropTypes.bool,
  externalLink: PropTypes.bool,
  location: PropTypes.string,
  subMenus: PropTypes.array,
  liClassName: PropTypes.string,
};

export default Item;
